import { CanAccess } from "@refinedev/core";
import { DashboardPage } from "pages/dashboard";
import { SupplierPortalPage } from "pages/supplier/Index";
import { isSupplierOnly } from "utility/helper";

export const HomePage: React.FC = () => {
  if (isSupplierOnly()) {
    return <SupplierPortalPage />;
  }

  return (
    <CanAccess fallback={<h1>Du saknar access till denna sida</h1>}>
      <DashboardPage />
    </CanAccess>
  );
};
